import { message } from 'antd';

// antd is already a dependency of this portal (see CustomerLayout.jsx's
// real-time socket `notification` toasts, themed via .customer-notification-toast
// in index.css) — this reuses the same library/pattern for one-off error
// snackbars instead of introducing a second toast system.
const DEFAULT_DURATION = 3;

export function showErrorToast(text) {
  message.error({
    content: text,
    duration: DEFAULT_DURATION,
    className: 'customer-portal-toast',
  });
}

export function showSuccessToast(text) {
  message.success({
    content: text,
    duration: DEFAULT_DURATION,
    className: 'customer-portal-toast customer-portal-toast--success',
  });
}
